import React from "react";
import useDrag from "../../hooks/useDrag";
import useResize from "../../hooks/useResize";
import { SCRLR_CONFIG } from "./config";

const WebPlayerScrlr = ({ onClose, onInteractionStateChange, initialPosition = { x: 0, y: 0 }, helpView = false, labels }) => {
  const { position, isDragging, dragHandlers, elementRef } = useDrag({ initialPosition });
  const { isResizing, handleResizeStart, elementRef: resizeRef } = useResize({
    aspectRatio: SCRLR_CONFIG.RESIZE.ASPECT_RATIO,
    minWidth: SCRLR_CONFIG.RESIZE.MIN_WIDTH,
    maxHeight: SCRLR_CONFIG.getMaxHeight()
  });
  
  // Use resize ref for the element (resize controls size, drag controls position)
  const combinedRef = (node) => {
    elementRef.current = node;
    resizeRef.current = node;
  };

  // Notify parent of interaction state changes
  React.useEffect(() => {
    if (onInteractionStateChange) {
      onInteractionStateChange(isDragging || isResizing);
    }
  }, [isDragging, isResizing, onInteractionStateChange]);

  return (
    <div 
      ref={combinedRef}
      className="webplayer-scrlr-modal-content" 
      onClick={(e) => e.stopPropagation()}
      style={{
        transform: `translate(${position.x}px, ${position.y}px)`
      }}
    >
      <div className="webplayer-scrlr-modal-header">
        <div
          className="webplayer-scrlr-drag-handle"
          {...dragHandlers}
        />
        {onClose && (
          <div onClick={onClose} className="close">
            <i className="fas fa-minus" />
          </div>
        )}
      </div>
      <div className="webplayer-scrlr-modal-body">
        <div className="spinner" />
        <iframe src={helpView ? SCRLR_CONFIG.getHelpUrl(labels) : SCRLR_CONFIG.getModalUrl()} id="webPlayerScrlr" />
      </div>
      {/* Top resize handles */}
      <div 
        className="webplayer-scrlr-resize-handle webplayer-scrlr-resize-handle-top-left"
        onMouseDown={(e) => {
          e.stopPropagation();
          handleResizeStart(e, 'top-left');
        }}
        onClick={(e) => e.stopPropagation()}
      />
      <div 
        className="webplayer-scrlr-resize-handle webplayer-scrlr-resize-handle-top-right"
        onMouseDown={(e) => {
          e.stopPropagation();
          handleResizeStart(e, 'top-right');
        }}
        onClick={(e) => e.stopPropagation()}
      />
      {/* Bottom overlay to block iframe interactions in resize area */}
      <div 
        className="webplayer-scrlr-bottom-overlay"
        style={{
          pointerEvents: isResizing ? 'auto' : 'none'
        }}
      >
        {/* Bottom resize handles */}
        <div 
          className="webplayer-scrlr-resize-handle webplayer-scrlr-resize-handle-bottom-left"
          onMouseDown={(e) => {
            e.stopPropagation();
            handleResizeStart(e, 'bottom-left');
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <div 
          className="webplayer-scrlr-resize-handle webplayer-scrlr-resize-handle-bottom-right"
          onMouseDown={(e) => {
            e.stopPropagation();
            handleResizeStart(e, 'bottom-right');
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  );
}

export default WebPlayerScrlr;